import {styled} from "@reside/ui";

export const LogoImage = styled.img`
  max-width: 200px;
  max-height: 150px;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  display: block;
  margin: 0 auto;

  @media (min-width: ${({theme}) => theme.breakpoint.lg}px) {
    margin: 0;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
`;

/**
 * CustomLogo component
 *
 * This component is used to display a custom logo image when creating a new organization theme. Also used on the admission entry pages.
 * It is styled to be centered and have a minimum height of 150px.
 *
 */

export const CustomLogo = ({
  src,
  alt,
  style,
}: {
  src: string;
  alt: string;
  style?: React.CSSProperties;
}): JSX.Element => {
  return (
    <LogoContainer id="custom-logo-container">
      <LogoImage src={src} alt={alt} style={style} />
    </LogoContainer>
  );
};
